import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { LeadAssignedCard } from '../Component/Lead Assigned/LeadAssignedCard';
import { useDispatch, useSelector } from 'react-redux';
import { Get_All_Lead_Assigned_Data_Action } from '../Redux/Actions/Lead_Assigned_Action';
import { Link, useParams } from 'react-router-dom';
import GetAppIcon from '@mui/icons-material/GetApp';
import XLSX from '../utils/excelUtils';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

export const LeadAssignedpage = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  //user login
  let userloginrealy = [];
  if (localStorage.getItem('user') !== null) {
    userloginrealy = JSON.parse(localStorage.getItem('user'));
  }

  const get_all_lead_assigned = async () => {
    setLoading(true);
    await dispatch(Get_All_Lead_Assigned_Data_Action(id));
    setLoading(false);
  };

  useEffect(() => {
    get_all_lead_assigned();
  }, []);

  const resleadassigned = useSelector((state) => state.AllLead_Assigned.Lead_Assigned);
  let LeadAssignedarray = Array.isArray(resleadassigned?.data) ? resleadassigned.data : [];

  // console.log(LeadAssignedarray,"LeadAssignedarray")
  const flattenData = (data) => {
    if (!Array.isArray(data)) {
      console.error('Expected an array but received:', data);
      return [];
    }
    return data.map((item) => ({
      id: item._id || 'N/A',
      Lead_Name: item.LeadId ? item.LeadId.name : 'N/A',
      Assigned_From_User: item.Assigned_From ? item.Assigned_From.name : 'N/A',
      Assigned_to_sales: item.Assigned_to ? item.Assigned_to.name : 'N/A',
      date_Assigned: item.date_Assigned || 'N/A',
    }));
  };

  const exportToExcel = () => {
    const flattenedData = flattenData(LeadAssignedarray);
    if (flattenedData.length === 0) {
      console.error('No data to export');
      return;
    }
    const ws = XLSX.utils.json_to_sheet(flattenedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Leads Data Assigned');
    XLSX.writeFile(wb, 'data.xlsx');
  };

  const getLinkByRole = (role) => {
    switch (role) {
      case 'Sales':
        return '/AllLeadsForSales';
      case 'Admin':
        return '/AllLeadsForAdmin';
      case 'Marketer':
        return '/ALLLeadsForMarketer';
      case 'Team Leader':
        return '/AllLeadsForTeamLeader';
      case 'Manager':
        return '/LeadsForManagers';
      default:
        return '/'; // أو أي مسار افتراضي
    }
  };

  const role = userloginrealy?.data?.role;
  const path = getLinkByRole(role);

  return (
    <div>
      <Container className="startpage">
        <Row style={{ width: '100%', display: 'flex' }}>
          <Col sm={2}></Col>
          <Col sm={10}>
            <div
              className="d-flex flex-wrap align-items-center my-3"
              style={{ gap: '0.5rem', fontSize: '1.1rem' }}
            >
              <Link
                to={path}
                style={{ textDecoration: 'none', color: '#0F7687', fontWeight: 'bold' }}
              >
                Home
              </Link>

              <KeyboardDoubleArrowRightIcon style={{ color: '#0F7687' }} />
              <span style={{ color: '#333' }}>Lead Assigned</span>
              {LeadAssignedarray.length > 0 ? (
                <span className="text-muted">({LeadAssignedarray.length})</span>
              ) : (
                <span className="text-muted">(No data available)</span>
              )}
            </div>

            <div
              onClick={exportToExcel}
              className="mx-2"
              style={{
                background: '#0F7687',
                color: 'white',
                width: '210px',
                textAlign: 'center',
                padding: '10px',
                cursor: 'pointer',
                borderRadius: '5px',
              }}
            >
              Export Data To Excel <GetAppIcon />
            </div>

            <div className="d-flex flex-wrap mt-3">
              {loading ? (
                <div className="w-100 d-flex justify-content-center align-items-center py-5">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : LeadAssignedarray.length > 0 ? (
                LeadAssignedarray.map((item, index) => (
                  <LeadAssignedCard key={index} items={item} />
                ))
              ) : (
                <div className="text-center w-100 text-muted py-4">No data available</div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
